"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.abbreviateTokenBN = exports.abbreviateStringNumber = void 0;
const abbreviate_1 = require("@pqt/abbreviate");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
exports.abbreviateStringNumber = (num) => {
    const numbersSplitted = num.split('.');
    const smallNumber = numbersSplitted[0] === '0';
    if (smallNumber) {
        const numToNumber = +num;
        const isTooSmall = numToNumber < 0.0001 && numToNumber > 0;
        const roundedNumber = (Math.round(numToNumber * 1000) / 1000).toString();
        return isTooSmall ? 'few' : roundedNumber;
    }
    else {
        const roundedNumber = Math.round(+num * 1000) / 1000;
        return abbreviate_1.abbreviate(roundedNumber, 4);
    }
};
exports.abbreviateTokenBN = (num, decimals) => {
    const amountWithDecimals = new bignumber_js_1.default(num);
    const bnDecimals = new bignumber_js_1.default(10).pow(new bignumber_js_1.default(decimals));
    const bnWithoutDecimals = amountWithDecimals
        .div(bnDecimals)
        .toFixed();
    const abbreviated = exports.abbreviateStringNumber(bnWithoutDecimals);
    return {
        abbreviated,
        withoutDecimals: bnWithoutDecimals,
        withDecimals: num
    };
};
//# sourceMappingURL=abbreviateHelper.js.map